import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    businessType: '',
    phone: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const {
      name,
      businessType,
      phone,
      message
    } = formData;
    const text = `Hola NovaWeb me interesa una página web para mi negocio.
    
*Nombre:* ${name}
*Tipo de Negocio:* ${businessType}
*Teléfono:* ${phone}
*Mensaje:* ${message}`;
    const encodedText = encodeURIComponent(text);
    const whatsappUrl = `https://wa.me/573508108717?text=${encodedText}`;
    window.open(whatsappUrl, '_blank');
  };
  return <section id="contacto" className="py-32 bg-[#0a0a1e] relative overflow-hidden" data-id="element-97">
      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-100">
            Contáctanos
          </h2>
          <div className="w-16 h-[3px] bg-[#00d4ff] mx-auto mt-4 mb-4" data-id="element-101" />
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-102">
            Déjanos tus datos y te contactaremos por WhatsApp para asesorarte
            sin compromiso.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/5 backdrop-blur-md border border-[#00d4ff]/20 rounded-3xl p-8 md:p-10 shadow-[0_0_40px_rgba(0,212,255,0.1)]" data-id="element-103">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-104">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-105">
              {/* Nombre */}
              <div data-id="element-106">
                <label htmlFor="name" className="block text-white text-sm font-medium mb-2" data-id="element-107">
                  Nombre Completo
                </label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} placeholder="Ej. Juan Pérez" className="w-full bg-transparent border border-[rgba(0,212,255,0.3)] rounded-xl px-4 py-3 text-white placeholder-[rgba(255,255,255,0.4)] focus:outline-none focus:border-[#00d4ff] focus:ring-1 focus:ring-[#00d4ff] transition-colors" data-id="element-108" />
              </div>

              {/* Tipo de Negocio */}
              <div data-id="element-109">
                <label htmlFor="businessType" className="block text-white text-sm font-medium mb-2" data-id="element-110">
                  Tipo de Negocio
                </label>
                <select id="businessType" name="businessType" required value={formData.businessType} onChange={handleChange} className="w-full bg-[#0a0a1e] border border-[rgba(0,212,255,0.3)] rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#00d4ff] focus:ring-1 focus:ring-[#00d4ff] transition-colors appearance-none" style={{
                color: formData.businessType ? 'white' : 'rgba(255,255,255,0.4)'
              }} data-id="element-111">
                  <option value="" disabled data-id="element-112">
                    Selecciona una opción
                  </option>
                  <option value="Restaurante" className="text-white" data-id="element-113">
                    Restaurante
                  </option>
                  <option value="Barbería" className="text-white" data-id="element-114">
                    Barbería
                  </option>
                  <option value="Clínica Dental" className="text-white" data-id="element-115">
                    Clínica Dental
                  </option>
                  <option value="Otro" className="text-white" data-id="element-116">
                    Otro
                  </option>
                </select>
              </div>
            </div>

            {/* Teléfono */}
            <div data-id="element-117">
              <label htmlFor="phone" className="block text-white text-sm font-medium mb-2" data-id="element-118">
                Número de Teléfono (WhatsApp)
              </label>
              <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} placeholder="Ej. 300 123 4567" className="w-full bg-transparent border border-[rgba(0,212,255,0.3)] rounded-xl px-4 py-3 text-white placeholder-[rgba(255,255,255,0.4)] focus:outline-none focus:border-[#00d4ff] focus:ring-1 focus:ring-[#00d4ff] transition-colors" data-id="element-119" />
            </div>

            {/* Mensaje */}
            <div data-id="element-120">
              <label htmlFor="message" className="block text-white text-sm font-medium mb-2" data-id="element-121">
                Mensaje
              </label>
              <textarea id="message" name="message" rows={4} required value={formData.message} onChange={handleChange} placeholder="Cuéntanos un poco sobre lo que necesitas..." className="w-full bg-transparent border border-[rgba(0,212,255,0.3)] rounded-xl px-4 py-3 text-white placeholder-[rgba(255,255,255,0.4)] focus:outline-none focus:border-[#00d4ff] focus:ring-1 focus:ring-[#00d4ff] transition-colors resize-none" data-id="element-122" />
            </div>

            {/* Submit Button */}
            <div className="pt-4 text-center" data-id="element-123">
              <button type="submit" className="inline-flex items-center justify-center gap-2 w-full md:w-auto px-10 py-4 rounded-[50px] font-bold text-white bg-gradient-to-r from-[#00d4ff] to-[#0077ff] shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105 transition-all duration-300" data-id="element-124">
                <Send size={20} data-id="element-125" />
                Enviar por WhatsApp
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </section>;
}